export default __webpack_public_path__ + "static/media/academic_partner.54202bba.png";